import * as type from '../../../actions/index.types';

const initialState = {
    noticesListLoading: false,
    noticesListData: null,
    noticesPagination: null,

    // Resident-facing published feed. Kept in its own slice so opening the
    // notice board never clobbers the admin list the user was filtering.
    noticeBoardLoading: false,
    noticeBoardData: null,
    noticeBoardPagination: null,

    noticeDetailsLoading: false,
    noticeDetailsData: null,

    createNoticeLoading: false,
    updateNoticeLoading: false,
    deleteNoticeLoading: false,

    publishLoading: false,
    archiveLoading: false,
    resendLoading: false,

    commentsLoading: false,
    commentsData: null,
    commentMutationLoading: false,
    attachmentLoading: false,

    acknowledgeLoading: false,
    acknowledgementsLoading: false,
    acknowledgementsData: null,

    noticeEnumsLoading: false,
    noticeEnumsData: null,

    // Targeting vocabulary: members with their owner/tenant/employee kinds,
    // flats with occupancy counts, and wings.
    audienceOptionsLoading: false,
    audienceOptionsData: null,

    statsLoading: false,
    statsData: null,

    error: null,
};

export function NoticeReducer(state = initialState, action) {
    switch (action.type) {
        case type.SOCIETY_GET_NOTICES_LIST:
            return { ...state, noticesListLoading: true, error: null };
        case type.SOCIETY_GET_NOTICES_LIST_SUCCESS: {
            const meta = action.payload?.pagination;
            const fallbackCount = action.payload?.count ?? action.payload?.total ?? 0;
            return {
                ...state,
                noticesListLoading: false,
                noticesListData: action.payload?.rows || action.payload?.data || action.payload || [],
                noticesPagination: meta || { total: fallbackCount, totalPages: Math.ceil(fallbackCount / 10) },
                error: null,
            };
        }
        case type.SOCIETY_GET_NOTICES_LIST_FAILURE:
            return { ...state, noticesListLoading: false, error: action?.message };

        case type.SOCIETY_GET_NOTICE_BOARD:
            return { ...state, noticeBoardLoading: true, error: null };
        case type.SOCIETY_GET_NOTICE_BOARD_SUCCESS: {
            const meta = action.payload?.pagination;
            const fallbackCount = action.payload?.count ?? action.payload?.total ?? 0;
            return {
                ...state,
                noticeBoardLoading: false,
                noticeBoardData: action.payload?.rows || action.payload?.data || action.payload || [],
                noticeBoardPagination: meta || { total: fallbackCount, totalPages: Math.ceil(fallbackCount / 10) },
                error: null,
            };
        }
        case type.SOCIETY_GET_NOTICE_BOARD_FAILURE:
            return { ...state, noticeBoardLoading: false, error: action?.message };

        case type.SOCIETY_GET_NOTICE_DETAILS:
            return { ...state, noticeDetailsLoading: true, error: null };
        case type.SOCIETY_GET_NOTICE_DETAILS_SUCCESS:
            return { ...state, noticeDetailsLoading: false, noticeDetailsData: action.payload, error: null };
        case type.SOCIETY_GET_NOTICE_DETAILS_FAILURE:
            return { ...state, noticeDetailsLoading: false, error: action?.message };

        case type.SOCIETY_CREATE_NOTICE:
            return { ...state, createNoticeLoading: true, error: null };
        case type.SOCIETY_CREATE_NOTICE_SUCCESS:
            return { ...state, createNoticeLoading: false, error: null };
        case type.SOCIETY_CREATE_NOTICE_FAILURE:
            return { ...state, createNoticeLoading: false, error: action?.message };

        case type.SOCIETY_UPDATE_NOTICE:
            return { ...state, updateNoticeLoading: true, error: null };
        case type.SOCIETY_UPDATE_NOTICE_SUCCESS:
            return { ...state, updateNoticeLoading: false, error: null };
        case type.SOCIETY_UPDATE_NOTICE_FAILURE:
            return { ...state, updateNoticeLoading: false, error: action?.message };

        case type.SOCIETY_DELETE_NOTICE:
            return { ...state, deleteNoticeLoading: true, error: null };
        case type.SOCIETY_DELETE_NOTICE_SUCCESS:
            return { ...state, deleteNoticeLoading: false, error: null };
        case type.SOCIETY_DELETE_NOTICE_FAILURE:
            return { ...state, deleteNoticeLoading: false, error: action?.message };

        case type.SOCIETY_PUBLISH_NOTICE:
            return { ...state, publishLoading: true, error: null };
        case type.SOCIETY_PUBLISH_NOTICE_SUCCESS:
            return { ...state, publishLoading: false, error: null };
        case type.SOCIETY_PUBLISH_NOTICE_FAILURE:
            return { ...state, publishLoading: false, error: action?.message };

        case type.SOCIETY_ARCHIVE_NOTICE:
            return { ...state, archiveLoading: true, error: null };
        case type.SOCIETY_ARCHIVE_NOTICE_SUCCESS:
            return { ...state, archiveLoading: false, error: null };
        case type.SOCIETY_ARCHIVE_NOTICE_FAILURE:
            return { ...state, archiveLoading: false, error: action?.message };

        case type.SOCIETY_RESEND_NOTICE:
            return { ...state, resendLoading: true, error: null };
        case type.SOCIETY_RESEND_NOTICE_SUCCESS:
            return { ...state, resendLoading: false, error: null };
        case type.SOCIETY_RESEND_NOTICE_FAILURE:
            return { ...state, resendLoading: false, error: action?.message };

        case type.SOCIETY_GET_NOTICE_COMMENTS:
            return { ...state, commentsLoading: true, error: null };
        case type.SOCIETY_GET_NOTICE_COMMENTS_SUCCESS:
            return { ...state, commentsLoading: false, commentsData: action.payload, error: null };
        case type.SOCIETY_GET_NOTICE_COMMENTS_FAILURE:
            return { ...state, commentsLoading: false, error: action?.message };

        case type.SOCIETY_ADD_NOTICE_COMMENT:
        case type.SOCIETY_DELETE_NOTICE_COMMENT:
            return { ...state, commentMutationLoading: true, error: null };
        case type.SOCIETY_ADD_NOTICE_COMMENT_SUCCESS:
        case type.SOCIETY_DELETE_NOTICE_COMMENT_SUCCESS:
            return { ...state, commentMutationLoading: false, error: null };
        case type.SOCIETY_ADD_NOTICE_COMMENT_FAILURE:
        case type.SOCIETY_DELETE_NOTICE_COMMENT_FAILURE:
            return { ...state, commentMutationLoading: false, error: action?.message };

        case type.SOCIETY_UPLOAD_NOTICE_ATTACHMENTS:
        case type.SOCIETY_DELETE_NOTICE_ATTACHMENT:
            return { ...state, attachmentLoading: true, error: null };
        case type.SOCIETY_UPLOAD_NOTICE_ATTACHMENTS_SUCCESS:
        case type.SOCIETY_DELETE_NOTICE_ATTACHMENT_SUCCESS:
            return { ...state, attachmentLoading: false, error: null };
        case type.SOCIETY_UPLOAD_NOTICE_ATTACHMENTS_FAILURE:
        case type.SOCIETY_DELETE_NOTICE_ATTACHMENT_FAILURE:
            return { ...state, attachmentLoading: false, error: action?.message };

        case type.SOCIETY_ACKNOWLEDGE_NOTICE:
            return { ...state, acknowledgeLoading: true, error: null };
        case type.SOCIETY_ACKNOWLEDGE_NOTICE_SUCCESS:
            return { ...state, acknowledgeLoading: false, error: null };
        case type.SOCIETY_ACKNOWLEDGE_NOTICE_FAILURE:
            return { ...state, acknowledgeLoading: false, error: action?.message };

        case type.SOCIETY_GET_NOTICE_ACKNOWLEDGEMENTS:
            return { ...state, acknowledgementsLoading: true, error: null };
        case type.SOCIETY_GET_NOTICE_ACKNOWLEDGEMENTS_SUCCESS:
            return { ...state, acknowledgementsLoading: false, acknowledgementsData: action.payload, error: null };
        case type.SOCIETY_GET_NOTICE_ACKNOWLEDGEMENTS_FAILURE:
            return { ...state, acknowledgementsLoading: false, error: action?.message };

        case type.SOCIETY_GET_NOTICE_ENUMS:
            return { ...state, noticeEnumsLoading: true, error: null };
        case type.SOCIETY_GET_NOTICE_ENUMS_SUCCESS:
            return { ...state, noticeEnumsLoading: false, noticeEnumsData: action.payload, error: null };
        case type.SOCIETY_GET_NOTICE_ENUMS_FAILURE:
            return { ...state, noticeEnumsLoading: false, error: action?.message };

        case type.SOCIETY_GET_NOTICE_AUDIENCE_OPTIONS:
            return { ...state, audienceOptionsLoading: true, error: null };
        case type.SOCIETY_GET_NOTICE_AUDIENCE_OPTIONS_SUCCESS:
            return { ...state, audienceOptionsLoading: false, audienceOptionsData: action.payload, error: null };
        case type.SOCIETY_GET_NOTICE_AUDIENCE_OPTIONS_FAILURE:
            return { ...state, audienceOptionsLoading: false, error: action?.message };

        case type.SOCIETY_GET_NOTICE_STATS:
            return { ...state, statsLoading: true, error: null };
        case type.SOCIETY_GET_NOTICE_STATS_SUCCESS:
            return { ...state, statsLoading: false, statsData: action.payload, error: null };
        case type.SOCIETY_GET_NOTICE_STATS_FAILURE:
            return { ...state, statsLoading: false, error: action?.message };

        default:
            return state;
    }
}

export default NoticeReducer;
